import { render } from "./Flash.vue?vue&type=template&id=105f80e0"
import script from "./Flash.vue?vue&type=script&lang=js"
export * from "./Flash.vue?vue&type=script&lang=js"

import "./Flash.vue?vue&type=style&index=0&id=105f80e0&lang=scss"

import exportComponent from "/var/www/vhosts/gilcode.com/kwordz.gilcode.com/packages/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__